/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { selectLocationState, useSelector } from "src/stateManagement/redux";

interface Props {
    show: any;
    setShowDetailMechanical: any;
}

const DiagramaMecanico = ({ show, setShowDetailMechanical }: Props) => {
    const { wellboreDiagram } = useSelector(selectLocationState);

    const [data, setData] = useState([])
    

    const handleShowDetailMechanical = (): void => {
        setShowDetailMechanical(!show);
    };

    const columns: GridColDef[] = [
        {
            field: "programStartDate",
            headerName: "Fecha Programa",
            minWidth: 100,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "programEndDate",
            headerName: "Fecha Termino",
            minWidth: 100,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "totalDepth",
            headerName: "Prof. Total (pies)",
            minWidth: 100,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "standingValveDepth",
            headerName: "Prof. VF (pies)",
            minWidth: 100,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pumpInstallationDate",
            headerName: "Fecha Inst. Bomba",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pumpSize",
            headerName: "Tamaño Bomba",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "plungerDiameter",
            headerName: "Diámetro Pistón",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pumpBrand",
            headerName: "Tipo Bomba",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "tubingJointsQuantity",
            headerName: "Tipo Bomba",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "tubingDiameters",
            headerName: "Diámetro Secciones de Tubería",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "tubingLength",
            headerName: "Longitud Secciones de Tubería",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "rodDiameters",
            headerName: "Diámetro Secciones de Cabilla",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "rodLengths",
            headerName: "Longitud Secciones de Cabilla",
            minWidth: 150,
            flex: 1,
            headerClassName: "wrap-header",
            headerAlign: "center",
            align: "center",
        },
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                {/* <DataGrid
                    rows={wellboreDiagram || []}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.id}
                /> */}
            </Grid>
        </Grid>
    );
};

export default DiagramaMecanico;
